/**
 * NikkiDailyReadCard — dashboard placement of Nikki's Daily Read.
 * Fetches GET /api/wellness/daily-read and renders the shared <NikkiDailyRead/>.
 * Refreshes on the global `wellness:refresh` event (fired after check-ins etc.)
 * so the read updates the moment the user logs how they feel.
 */
import React, { useEffect, useState, useCallback } from 'react';
import api from '../services/api';
import NikkiDailyRead from './NikkiDailyRead';

const NikkiDailyReadCard = () => {
  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await api.getDailyRead();
      setData(res.data);
    } catch (e) {
      setData(null);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    load();
    const onRefresh = () => load();
    window.addEventListener('wellness:refresh', onRefresh);
    return () => window.removeEventListener('wellness:refresh', onRefresh);
  }, [load]);

  if (!loaded || !data) return null;
  return <NikkiDailyRead data={data} variant="dashboard" />;
};

export default NikkiDailyReadCard;
